module.exports = "<ul class=\"g-admin-acordion-list-body\" [collapse]=\"collapse\">\n  <ng-content></ng-content>\n</ul>"